<mat-card class="container-card mat-elevation-z8">
    <!-- Messaggio informativo -->
    <mat-card-content>
        <div class="info-row">
            <mat-icon color="primary" class="info-icon">info</mat-icon>
            <span class="info-text">
        Aggiungi le URL dei documenti da eliminare.
        Es: <code>http://www\.domain\.net/downloads/.*\.pdf</code>
      </span>
        </div>
    </mat-card-content>

    <mat-card-content class="my-3">
        <form [formGroup]="formData" (ngSubmit)="cancellaDocumenti()">
            <div formArrayName="inputUrlsArray" class="url-list">
                <div *ngFor="let url of inputUrls.controls; let i = index" [formGroupName]="i" class="url-row">
                    <mat-form-field appearance="fill" class="url-field w-100">
                        <mat-label>URL Documento <span aria-hidden="true">*</span></mat-label>
                        <input matInput [formControlName]="'documentUrl'" autocomplete="off" spellcheck="false" inputmode="url" />

                        <!-- delete-->
                        <div matSuffix class="url-actions">
                            <button *ngIf="inputUrls.length > 1" type="button" mat-icon-button color="warn" aria-label="Elimina URL" (click)="removeUrl(i)">
                <mat-icon>delete</mat-icon>
              </button>
                        </div>

                        <mat-error *ngIf="url.get('documentUrl')?.hasError('required')">
                            Il campo è obbligatorio
                        </mat-error>
                        <mat-error *ngIf="url.get('documentUrl')?.hasError('pattern')">
                            URL non valido
                        </mat-error>
                    </mat-form-field>

                    <!-- add-->
                    <div class="url-add"> <button *ngIf="i === inputUrls.length - 1" class="btn-primary add-url-button my-3" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="aggiungiUrl()">
              Aggiungi URL
            </button> </div>
                </div>
            </div>

            <div class="delete-action">
                <button type="submit" class="btn-primary btn-delete-document" [disabled]="!formData.valid || isDeleting || !canDoActions('BACKOFFICE_ADMIN')">
          <mat-progress-spinner *ngIf="isDeleting" diameter="20" mode="indeterminate"></mat-progress-spinner>
          <span class="ml-2">Cancella Documenti</span>
        </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>